export enum PageLinkTypeEnum {
    NONE = 'NONE',
    URL = 'URL',
    PAGE = 'PAGE',
    PRODUCT_FILTER = 'PRODUCT_FILTER',
}
